@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-carousel {
    display: block;

    // ==== "controlsOnHover" Prop Styles

    &.controls-on-hover {
      outline: none;

      &:not(:hover) {
        &:not(:focus-visible) {
          &:not(:focus-within) {
            .nav-controls-container {
              @include fade-out();
            }
          }
        }
      }

      &:hover,
      &:focus-visible,
      &:focus-within {
        .nav-controls-container {
          @include fade-in();
        }
      }
    }

    // ==== Navigation Controls Container

    .nav-controls-container {
      margin: 0.5em 0;
      display: flex;
      justify-content: center;
      column-gap: 1em;
    }

    // ==== Indicators Container

    .slide-indicators-container {
      display: flex;
      align-items: center;
    }

    // ==== iOS-Style Slide Indicator

    .slide-indicator {
      @include button-reset;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 1.5em;
      position: relative;

      // == Indicator "Dot"

      &::after {
        display: block;
        width: var(--btn-size);
        height: var(--btn-size);
        border-radius: 100em;
        background-color: var(--background-color);
        content: '';

        @include transition($properties: 'background-color',
          $duration: short);
      }

      // == Hover / Focus Styles

      &:hover,
      &:focus-visible {
        &::after {
          background-color: var(--background-color-hover);
        }
      }

      // == "Active" Indicator

      &.slide-active {
        &::after {
          background-color: var(--active-color);
        }
      }
    }
  }
}